module.exports = __webpack_public_path__ + "static/media/unknownbot.e6896da0.png";